import { Flex } from 'front-commons/ds';
import { ContainerBoni } from './styles';
import { Icon, Typography } from 'hype-ds';
import { ContainerBoniProps } from './interfaces';
import useBoniVisibility from 'containers/Boni/hooks/useBoniVisibility';
import { useResponsive } from 'front-commons/hooks';
import useViewPort from 'hooks/useViewPort';
import { useEffect } from 'react';
import { onBannerBoniView, onBannerBoniClick } from 'shared/gtm';

export function BoniBanner({ variant }: { variant: ContainerBoniProps['variant'] }) {
	const { showBoniBanner, compactBanner, navigateToFidelityPage } = useBoniVisibility();
	const { small } = useResponsive();
	const { isInViewPort, ref } = useViewPort({ once: true });

	const bannerId = compactBanner ? 'boni_banner_compact' : 'boni_banner_default';

	const isVerticalLayout = variant === 'revision' || small;
	const ResponsiveLabel = Typography.Label[isVerticalLayout ? 'S' : 'M'];
	const origin = variant === 'revision' ? 'revision' : 'cart';

	if (!showBoniBanner) return null;

	useEffect(() => {
		if (!isInViewPort) return;
		onBannerBoniView(bannerId);
	}, [isInViewPort, bannerId]);

	const handleClick = () => {
		onBannerBoniClick(bannerId, origin);
		navigateToFidelityPage();
	};

	return (
		<div ref={ref}>
			<ContainerBoni
				as="button"
				width="100%"
				cursor="pointer"
				padding={isVerticalLayout ? '16px' : '24px 16px'}
				variant={variant}
				onClick={handleClick}
				data-component="boni-banner"
				data-banner-variant={compactBanner ? 'compact' : 'default'}
			>
				<Flex
					zIndex={1}
					color="--boni-purple700"
					gap="8px"
					width="100%"
					direction={{ small: 'column', medium: isVerticalLayout ? 'column' : 'row' }}
				>
					<Flex gap="16px">
						<Flex alignItems={isVerticalLayout ? 'initial' : 'center'}>
							<img
								src="/boni-logo-purple.png"
								alt="logo do boni"
								width="48px"
								style={{ objectFit: 'contain' }}
								height="48px"
							/>
						</Flex>
						<Flex direction="column" width="200px" gap="0" alignItems="flex-start">
							<Typography.Heading.XXS color="--boni-purple700">Programa Fidelidade Boni</Typography.Heading.XXS>
							{compactBanner ? (
								<Typography.Paragraph.S color="--text-primary">Ganhe pontos a cada compra.</Typography.Paragraph.S>
							) : (
								<Typography.Paragraph.S color="--text-primary" whiteSpace="pre-line">
									Ganhe 100 pontos na 1ª compra{'\n'}e acumule mais a cada pedido.
								</Typography.Paragraph.S>
							)}
						</Flex>
					</Flex>
					<Flex
						direction={isVerticalLayout ? 'column' : 'row'}
						alignItems={isVerticalLayout ? 'flex-start' : 'center'}
						justifyContent={isVerticalLayout ? 'initial' : 'space-between'}
						gap="8px"
						margin={isVerticalLayout ? '0 0 0 64px' : undefined}
					>
						<Flex
							gap={isVerticalLayout ? '4px' : '8px'}
							width={isVerticalLayout ? '119px' : '127px'}
							border="1px solid"
							cursor="pointer"
							height="40px"
							padding={isVerticalLayout ? '5px' : '10px'}
							alignItems="center"
							borderColor="--boni-purple700"
							borderRadius="8px"
							justifyContent="center"
							backgroundColor="--surface-white"
						>
							<ResponsiveLabel color="--boni-purple700">Saiba mais</ResponsiveLabel>
							<Icon name="chevron_right" size={isVerticalLayout ? '16px' : '20px'} color="--boni-purple700" />
						</Flex>
					</Flex>
				</Flex>
			</ContainerBoni>
		</div>
	);
}
